module.exports = __webpack_public_path__ + "static/media/fondo-seccion-vehicular.e02281cd.webp";